module.exports = __webpack_public_path__ + "img/orange_084.afb2c64f.png";